const styles = {
  search: {
    display: "flex",
    justifyContent: "space-between",
    gap: "20px",
  },
  searchButton: {
    color: "#FFFFFF",
    borderRadius: "0.5rem",
    padding: "0.5rem 3rem",
  },
};

export default styles;
